import { useTrackingDataStore } from '@/stores/trackingData.js';
import { useRoute } from 'vue-router';
import { getUtmSource } from '@/router/queryParam.js';
import { inject, onMounted, onUnmounted } from 'vue';
import { sendAnalytics } from '@/services/analytics.js';

export const useDataRefreshOnVisibilityChange = (analyticsSuffix = '') => {
  const store = useTrackingDataStore();
  const route = useRoute();

  const $rttI18n = inject('rttI18n');
  const $t = inject('t');

  const refreshTrackingData = source => {
    if (store.shouldRefreshTrackingData(true)) {
      sendAnalytics(
        store.data,
        'visibility_refreshed',
        `refresh_visibility_changed_via_${analyticsSuffix}`,
        { isV2: true, source }
      );

      store.updateTrackingWithTitleAndSessionUpdate(
        {
          utmSource: getUtmSource(route),
          tenantId: $rttI18n.tenantId,
          trackingId: route.params.trackingId,
          postcode: route.params.postcode
        },
        true,
        $t
      );
    }
  };

  const handleVisibilityChange = () => refreshTrackingData('visibilitychange');

  const handleFocus = () => refreshTrackingData('focus');

  onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);
  });

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('focus', handleFocus);
  });
};
